import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ProductVariant} from '@mintdata-wsp/common/controllers/network/generated/responses/ProductVariant';
import {ChargePeriod} from '@mintdata-wsp/common/state/ui/storefront/ChargePeriod';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {ChargePeriodSwitcher} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/plans/ChargePeriodSwitcher';

const styles = require('./LiveReceipt.less');
const cx = classnames.bind(styles);

@observer
export class LiveReceipt extends React.Component<any, any>
{
    render()
    {
        const controller = controllers.ui.productSelection;
        const selectionState = rootState.ui.productSelectionState;

        const {selectedCloudAccess} = selectionState;
        const {selectedAddons} = selectionState;
        const {selectedChargePeriod} = selectionState;

        const monthlyTotalString = controller.getReceiptTotalInPerMonthUnits();
        const totalString = controller.getReceiptTotal();
        const savingsString = controller.getAnnualSavingsTotal();

        return <Column className={cx('liveReceipt')}>

                    <Row className={cx('receiptHeader')}>
                        <Row className={cx('receiptHeaderText')}>Cloud Plan</Row>
                    </Row>

                    {
                        selectedCloudAccess? this._renderProduct(selectedCloudAccess) : null
                    }

                    <Row className={cx('receiptHeader')}>
                        <TextRun className={cx('receiptHeaderText')}>Addons</TextRun>
                    </Row>
                    {
                        selectedAddons && selectedAddons
                            .map((addonProduct:Product)=>
                            {
                                return this._renderProduct(addonProduct);
                            })
                    }

                    <Row className={cx('receiptHeader')}>
                        <Row className={cx('receiptHeaderText')}>Total</Row>
                    </Row>

                    {
                        controller.isAnnualChargePeriodSelected() ?
                            <Row className={cx('receiptTotalRow')}>
                                <Row className={cx('receiptTotalLabel')}>Per month</Row>
                                <Row className={cx('receiptTotalValue')}>${monthlyTotalString}</Row>
                            </Row>
                            :
                            null
                    }

                    <Row className={cx('receiptTotalRow')}>
                        <Row className={cx('receiptTotalLabel')}>Per {ChargePeriod.formatForDisplay(selectedChargePeriod)}</Row>
                        <Row className={cx('receiptTotalValue')}>${totalString}</Row>
                    </Row>

                    {
                        controller.isAnnualChargePeriodSelected() ?
                            <Row className={cx('receiptAnnualSavingsRow')}>
                                <Row className={cx('receiptTotalLabel')}>Annual Savings</Row>
                                <Row className={cx('receiptTotalValue')}>${savingsString}</Row>
                            </Row>
                            :
                            null
                    }

                    <Row className={cx('chargePeriodRow')}>
                        <Row className={cx('billedLabel')}>Billed</Row>
                        <ChargePeriodSwitcher className={cx('chargePeriodSwitcher')}/>
                    </Row>

                </Column>;
    }

    private _getAnnualPriceInMonthlyUnits(product: Product):string | null
    {
        const controller = controllers.ui.productSelection;

        if( !controller.isAnnualChargePeriodSelected() )
            return null;

        const monthlyVariant:ProductVariant = controller.findMonthlyVariant(product);
        if( !monthlyVariant )
            return null;

        return ChargePeriod.formatPrice(monthlyVariant.price);
    }

    private _renderRowItemDiscount(product:Product)
    {
        const controller = controllers.ui.productSelection;
        const formattedAnnualPriceInMonthlyUnits = this._getAnnualPriceInMonthlyUnits(product);

        return controller.isAnnualChargePeriodSelected() ?
            <Row className={cx('productPriceStrikethroughRow')}>
                ${formattedAnnualPriceInMonthlyUnits}
            </Row>
            :
            null;
    }

    private _renderProduct(product: Product):JSX.Element
    {
        const controller = controllers.ui.productSelection;
        const currentVariant = controller.getCurrentVariant(product);

        if( !currentVariant )
            return null;

        // const monthlyPrice = ChargePeriod.getPricePerMonth(currentVariant);

        const monthlyPrice = controller.getPriceInPerMonthTerms(product, currentVariant);
        const formattedMonthlyPrice = ChargePeriod.formatPrice(monthlyPrice);

        return  <Row key={product.productId} className={cx('receiptRow')}>
                    <Column className={cx('productInfoColumn')}>
                        <div className={cx('productName')}>
                            {product.name}
                        </div>
                        {/*<div className={cx('productDescription')}>*/}
                            {/*{product.description}*/}
                        {/*</div>*/}
                    </Column>
                    <Column className={cx('productPriceColumn')}>

                        <Row>
                            {/*{this._renderRowItemDiscount(product)}*/}

                            <Row className={cx('productPriceRow')}>
                                ${formattedMonthlyPrice}
                            </Row>
                        </Row>

                    </Column>
                </Row>;
    }
}
